<template>
  <section class="dp-layout">

    <section class="dp-left">
      <DepartmentPane directory-scope="school" @tree-node-click="treeNodeClick" :type="1"></DepartmentPane>
    </section>

    <section class="dp-right">
      <!--工具条-->
      <toolbar :buttonList="buttonList" @callFunction="callFunction" :searchList="searchList"></toolbar>

      <!--列表-->
      <div class="tbl-scroll-host">
      <el-table :data="users" v-loading="listLoading" @select="dialogCheck" @row-click="selectCurrentRow" ref="table"
        height="100%" style="width: 100%" class="custom-tbl">
        <el-table-column prop="TerminalId" label="终端号" width></el-table-column>
        <el-table-column prop="TerminalName" label="终端名称" width></el-table-column>
        <el-table-column prop="SeatNumber" label="乘车总人数" width></el-table-column>
        <el-table-column prop="DepartmentName" label="部门" width></el-table-column>

        <el-table-column label="开始接送" header-align="center">
          <el-table-column prop="GpsTime" label="时间" width></el-table-column>
          <el-table-column prop="GpsLatitude" label="纬度" width></el-table-column>
          <el-table-column prop="GpsLongitude" label="经度" width></el-table-column>
          <!-- <el-table-column prop="CardId" label="地址" width></el-table-column> -->
          <el-table-column prop="ImageFile" label="文件" align="center" header-align="center">
            <template slot-scope="scope">
              <oss-media-thumbs :media="scope.row.ImageFile" />
            </template>
          </el-table-column>
        </el-table-column>

        <el-table-column label="结束接送" header-align="center">
          <el-table-column prop="StopGpsTime" label="时间" width></el-table-column>
          <el-table-column prop="StopGpsLatitude" label="纬度" width></el-table-column>
          <el-table-column prop="StopGpsLongitude" label="经度" width></el-table-column>
          <!-- <el-table-column prop="StopGpsAddress" label="地址" width></el-table-column> -->
          <el-table-column prop="StopImageFile" label="文件" align="center" header-align="center">
            <template slot-scope="scope">
              <oss-media-thumbs :media="scope.row.StopImageFile" />
            </template>
          </el-table-column>
        </el-table-column>

        <!-- ... existing code ... -->
        <el-table-column label="乘车人" width>
          <template slot-scope="scope">
            <span @click="showPassengerDetail(scope.row)" class="clickable">
              {{ scope.row.PassengerNumber }}
            </span>
          </template>
        </el-table-column>
        <el-table-column label="未乘车人" width>
          <template slot-scope="scope">
            <span @click="showNoPassengerDetail(scope.row)" class="clickable">
              {{ scope.row.NoPassengerNumber }}
            </span>
          </template>
        </el-table-column>

      </el-table>
      </div>

      <!--工具条-->
      <el-col :span="24" class="toolbar">
        <el-pagination layout="total, prev, pager, next, jumper" @current-change="handleCurrentChange" :page-size="10" :total="total"
          style="float: right"></el-pagination>
      </el-col>
    </section>

    <el-dialog title="乘车人员" :visible.sync="passengerDialogVisible" width="55%" center destroy-on-close>

      <!--详情-->
      <el-table :data="passengerData" v-loading="listLoading" ref="table" style="width: 100%" class="custom-tbl">
        <el-table-column prop="UserName" label="姓名" width></el-table-column>
        <el-table-column prop="UserCardId" label="卡号" width></el-table-column>
        <el-table-column prop="DeptName" label="班级" width></el-table-column>
        <el-table-column prop="Time" label="刷卡时间" width></el-table-column>

        <el-table-column fixed="right" label="操作" width="80">
          <template slot-scope="scope">
            <el-button @click="showHistory(scope.row)" type="text">查看</el-button>
          </template>
        </el-table-column>
      </el-table>

      <el-col :span="24" class="toolbar">
        <el-pagination layout="total, prev, pager, next, jumper" @current-change="passengerDataChange" :page-size="10"
          :total="passengerDataTotal" style="float: right"></el-pagination>
      </el-col>

      <div slot="footer" class="dialog-footer">
        <el-button @click="passengerDialogVisible = false">取 消</el-button>
      </div>

    </el-dialog>

    <el-dialog :title="historyDataTitle" :visible.sync="dialogVisible" width="40%" center destroy-on-close>
      <el-table :data="historyData" class="custom-tbl" style="width: 100%">
        <el-table-column property="Time" label="时间"></el-table-column>
        <el-table-column property="KqTerminalId" label="终端编码"></el-table-column>
        <el-table-column property="KqTerminalName" label="终端名称"></el-table-column>
        <el-table-column property="TouchType" label="刷卡类型"></el-table-column>
      </el-table>

      <el-col :span="24" class="toolbar">
        <el-pagination layout="total, prev, pager, next, jumper" @current-change="handleHistoryDataChange" :page-size="10"
          :total="historyDataTotal" style="float: right"></el-pagination>
      </el-col>

      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
      </div>
    </el-dialog>


  </section>
</template>

<script>
import util from "../../../util/date";
import { getSchoolBusPickRecords, getSchoolBusPassengerListPage, getetSchoolBusRecords, exportSchoolBusPickRecords } from '../../api/modules/misc';
import { BaseApiUrl } from '../../api/base';
import { getButtonList } from "../../promissionRouter";
import Toolbar from "../../components/Toolbar";
import DepartmentPane from '../../components/DepartmentPane'

export default {
  components: { Toolbar, DepartmentPane },
  data() {
    return {
      filters: {
      },
      searchList: [
        {
          label: '日期',
          key: 'date',
          type: 'date'
        },
        {
          label: '校车名称',
          key: 'schoolBusName',
        }
      ],
      buttonList: [],
      options: [],
      users: [],
      defaultProps: {
        children: "children",
        label: "label",
      },
      statusList: [
        { name: "激活", value: true },
        { name: "禁用", value: false },
      ],
      total: 0,
      page: 1,
      listLoading: false,
      sels: [], //列表选中列
      currentRow: null,
      isResouceShow: 0,
      DepartmentId: "",
      BaseApiUrl: BaseApiUrl, //网络前缀
      passengerDialogVisible: false,
      passengerDataTotal: 0,
      passengerPage: 1,
      passengerData: [],
      currentType: 1,

      currentDate: "",
      historyUserId: 0,
      dialogVisible: false,
      historyData: [],
      historyDataTitle: "",
      historyDataTotal: 0,
      historyDataPage: 1,
    };
  },
  computed: {
  },
  methods: {
    treeNodeClick(data, node, component) {
      this.DepartmentId = data.value
      this.handleQuery();
    },

    dialogCheck(selection, row) {
      this.currentRow = null;
      this.$refs.table.clearSelection();
      if (selection.length === 0) {
        return;
      }
      if (row) {
        this.selectCurrentRow(row);
      }
    },
    selectCurrentRow(val) {
      if (val) {
        this.currentRow = val;
        this.$refs.table.clearSelection();
        this.$refs.table.toggleRowSelection(val, true);
      }
    },
    callFunction(item) {
      this.currentDate = item.search.date || "";
      if (typeof item.search == 'object') {
        this.filters = item.search
      } else {
        this.filters = {
          key: item.search,
        }
      }
      this[item.Func].apply(this, item)
    },
    handleCurrentChange(val) {
      this.page = val;
      this.handleQuery();
    },
    //获取用户列表
    handleQuery() {
      let _this = this;
      let para = {
        page: this.page,
        departmentId: this.DepartmentId,
        ...this.filters,
      };
      this.listLoading = true;
      //NProgress.start();
      getSchoolBusPickRecords(para).then(async (res) => {
        this.total = res.data.response.dataCount;
        const rows = res.data.response.data || [];
        await this.prefetchListOssMedia(rows, ['ImageFile', 'StopImageFile']);
        this.users = rows;
        this.listLoading = false;
        //NProgress.done();
      });
    },

    passengerDataChange(val) {
      this.passengerPage = val;
      this.handleQueryPassengerData();
    },

    //获取乘坐人
    handleQueryPassengerData() {
      let _this = this;
      let para = {
        page: this.passengerPage,
        ...this.filters,
        schoolBusId: this.currentRow.SchoolBusId,
        recordId: this.currentRow.Id,
        type: this.currentType
      };
      this.listLoading = true;

      getSchoolBusPassengerListPage(para).then((res) => {
        this.passengerData = res.data.response.data;
        this.passengerDataTotal = res.data.response.dataCount;
        this.listLoading = false;
      });
    },

    showPassengerDetail(row) {
      this.currentRow = row;
      this.passengerDialogVisible = true;
      this.currentType = 1;
      this.handleQueryPassengerData();
    },
    showNoPassengerDetail(row) {
      this.currentRow = row;
      this.passengerDialogVisible = true;
      this.currentType = 0;
      this.handleQueryPassengerData();
    },

    showHistory(row) {
      this.historyUserId = row.UserId;
      this.historyDataTitle = "【" + row.UserName + "】" + this.currentDate + "刷卡明细";
      this.handleHistoryDataQuery();
    },

    handleHistoryDataChange(val) {
      this.historyDataPage = val;
      this.handleHistoryDataQuery();
    },

    handleHistoryDataQuery() {
      let para = {
        page: this.historyDataPage,
        departmentId: this.DepartmentId,
        date: this.currentDate,
        userAccountUid: this.historyUserId,
        recordId: this.currentRow.Id
      };
      getetSchoolBusRecords(para).then((res) => {
        this.historyDataTotal = res.data.response.dataCount;
        this.historyData = res.data.response.data;
        this.$nextTick(() => { this.dialogVisible = true; })
      });
    },
    
    async exportExcel() {
      try {
        let para = {
          page: this.page,
          departmentId: this.DepartmentId,
          ...this.filters,
        };

        var fileName = "校车终端考勤报表";
        const response = await exportSchoolBusPickRecords(para);
        if (!response.data) {
          this.$message({
            message: "导出数据为空",
            type: "error",
          });
          return;
        }
        // 处理导出数据        
        const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', fileName + '.xlsx');
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
      } catch (error) {
        console.error('下载失败:', error);
      }
    },

  },
  mounted() {
    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : [];

    this.buttonList = getButtonList(this.$route.path, routers);
  },
};
</script>

<style scoped>
.custom-tbl /deep/ .has-gutter .el-checkbox {
  display: none;
}

.clickable {
  cursor: pointer;
}
</style>
